import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import styles from './TerminateBillingAgreementDialog.styles.scss';
import cn from 'classnames';
import { Formik, Form } from 'formik';
import { terminateAgreementFormConfig } from './config/formConfig';
import { terminateAgreementValidationSchema } from './config/validation';
import { terminateAgreementInitialValues } from './config/initialValues';
import { FormikField } from '../../../../components/FormikField';

const TerminateBillingAgreementDialog = ({
  terminateAgreements,
  setTerminateAgreements,
  confirmTerminateAgreements,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onHide={() => setTerminateAgreements(false)}
      className={cn(
        'rounded-4 overflow-hidden',
        styles.terminateBillingAgreementDialog,
      )}
      visible={!!terminateAgreements}
    >
      <div className={styles.submissionMessage}>
        <span>
          <div>
            <i className="pi pi-file-excel" />
          </div>
        </span>
        <h3>{t('special_billing.terminate-agreement')}</h3>
        <p>{t('special_billing.terminate-agreement_desc')}</p>
        <div>
          <Formik
            validateOnMount
            enableReinitialize
            validationSchema={terminateAgreementValidationSchema({
              t,
            })}
            initialValues={terminateAgreementInitialValues()}
            onSubmit={(form) => {
              confirmTerminateAgreements(terminateAgreements, form.reason).then(
                () => {
                  setTerminateAgreements(false);
                },
              );
            }}
          >
            {({ values, errors }) => {
              return (
                <Form className={styles.failureForm}>
                  {terminateAgreementFormConfig({
                    t,
                  }).map((section) => (
                    <div key={section.title}>
                      <h2>{section.title}</h2>
                      <div className={styles.formSection}>
                        {section.fields
                          .filter((item) => !item.hide)
                          .map((field) => (
                            <div
                              key={field.name}
                              className={styles.fieldWrapper}
                            >
                              <label
                                className={cn(
                                  field.required ? styles.requiredLabel : '',
                                  styles[field.labelClassName],
                                )}
                                htmlFor={field.name}
                              >
                                {field.label}
                              </label>
                              <FormikField
                                name={field.name}
                                component={field.component}
                                error={errors[field.name]}
                                controlProps={{ ...field.controlProps }}
                                componentProps={{
                                  ...field.componentProps,
                                  className: cn(
                                    field.componentProps?.className,
                                    styles[field.componentProps?.className],
                                  ),
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
                  <Divider className="my-4" />
                  <div className={styles.formActions}>
                    <Button
                      label={t('common.cancel')}
                      outlined
                      className={styles.formBtn}
                      type="button"
                      onClick={() => setTerminateAgreements(false)}
                    />
                    <Button
                      type="submit"
                      className={styles.formBtn}
                      label={t('special_billing.terminate-agreement_btn')}
                      disabled={Object.keys(errors).length > 0 && !values.terms}
                    />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </Dialog>
  );
};

export default TerminateBillingAgreementDialog;
